import type { ModeloDoCartao } from './acoes-da-fila';

export interface AcoesDaMinhaRealizacao {
  editar: boolean;
  excluir: boolean;
  atualizarIndicador: boolean;
  solicitarAutorizacao: boolean;
}

/**
 * RDN-10: as ações da realização própria nas mesmas condições em que o `TaskItem` as mostra (expressões copiadas do
 * JSX dele, sem mudança): Editar no bloco `(editable || reset) && !isView`; Solicitar autorização no aviso de
 * participantes pendentes; Atualizar indicador com `canUpdateIndicator`. Excluir segue `canDelete` do modelo, a regra
 * da exclusão por action_log (RDD-01, RDD-02): dono, ciclo da realização aberto, fora da visualização e do gestor.
 */
export function acoesDaMinhaRealizacao(modelo: ModeloDoCartao): AcoesDaMinhaRealizacao {
  const { data, editable, reset, isView, canUpdateIndicator, stepTask, user, realDatetime } = modelo;
  const blocoDeEdicao = (!!editable || !!reset) && !isView;

  return {
    editar: blocoDeEdicao && !!editable,
    excluir: !!modelo.canDelete,
    atualizarIndicador: !!canUpdateIndicator,
    solicitarAutorizacao:
      !!stepTask &&
      user?._id === data?.owner &&
      realDatetime < stepTask?.date_evaluation_step2_finish &&
      data.participants_approval?.status === 'pending' &&
      data?.managers_to_approve?.length > 0,
  };
}
